// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1J-sv","infoBtn":"quickbooks_infoBtn__2Cjk-","formBox":"quickbooks_formBox__2ZmQ8","formFooter":"quickbooks_formFooter__2sX3S"};